export const autoscroller = (root) => {
    let gap = 30; // Initial gap (will be adjusted dynamically)
    const offsetAmount = 7.5; // Offset for odd/even cards
    const scrollSpeed = 1; // Pixels to scroll per frame
    const scrollInterval = 50; // Milliseconds between scroll frames
    let autoScroll = null; // For controlling the scrolling interval

    // Function to check if the container is overflowing
    function isOverflowing() {
        return root.scrollWidth > root.clientWidth;
    }

    // Dynamically adjust the gap to ensure sufficient overflow
    function adjustGap() {
        const cards = Array.from(root.children);
        const totalCardWidth = cards.reduce((acc, card) => acc + card.offsetWidth, 0);
        const totalGapWidth = gap * (cards.length - 1);
        const totalTrackWidth = root.clientWidth;
        const cardWidth = cards[0].offsetWidth;
        const neededMinimumSlack = cardWidth + gap;

        const roomStillNeeded = totalTrackWidth + neededMinimumSlack - (totalCardWidth + totalGapWidth);
        // if roomStillNeeded is positive, we need to add that much to the gap
        if (roomStillNeeded > 0) {
            const newGap = gap + roomStillNeeded / (cards.length - 1); // doing this on two lines for sanity
            // now we need to adjust the minimum slack to account for the wider gap
            const addToGap = Math.round( (newGap - gap) / cards.length - 1) + 1;
            root.style.gap = `${newGap + addToGap}px`;
        }
    }

    // Apply initial offsets to cards
    function setInitialOffsets() {
        Array.from(root.children).forEach((card, index) => {
            const offset = index % 2 === 0 ? -offsetAmount : offsetAmount;
            card.style.position = "relative";
            card.style.top = `${offset}px`;
            card.dataset.offset = `${offset}`; // Save offset for cloning
        });
    }

    // Swap the first card to the end of the container
    function wrapFirstToLast() {
        const firstCard = root.firstElementChild;

        if (firstCard) {
            const cardWidth = firstCard.offsetWidth + gap;

            // Check if the first card is fully out of view
            if (root.scrollLeft >= cardWidth) {
                stopScrolling(); // Temporarily stop autoscrolling

                // Clone the first card while preserving its offset
                const clonedCard = firstCard.cloneNode(true);
                clonedCard.style.top = `${firstCard.dataset.offset}px`;
                root.appendChild(clonedCard);
                firstCard.remove();

                // Adjust the scroll position to maintain smooth scrolling
                root.scrollLeft -= cardWidth;

                // Restart autoscrolling after the swap
                setTimeout(() => {
                    startScrolling();
                }, scrollInterval);
            }
        }
    }

    // Scroll the container to the right
    function scrollRight() {
        root.scrollLeft += scrollSpeed;
        wrapFirstToLast(); // Check and handle wrapping
    }

    // Start the autoscrolling process
    function startScrolling() {
        if (!autoScroll) {
            autoScroll = setInterval(scrollRight, scrollInterval);
        }
    }

    // Stop the autoscrolling process
    function stopScrolling() {
        if (autoScroll) {
            clearInterval(autoScroll);
            autoScroll = null;
        }
    }

    // Align cards based on overflow status
    function updateAlignment() {
        root.style.justifyContent = isOverflowing() ? "flex-start" : "center";
    }

    // Set up event listeners
    root.addEventListener("mouseover", stopScrolling);
    root.addEventListener("mouseout", startScrolling);

    // Update alignment on resize
    window.addEventListener("resize", updateAlignment);

    // Initial setup
    updateAlignment();
    if (isOverflowing()) {
        adjustGap(); // Ensure sufficient overflow
        setInitialOffsets(); // Apply offsets to cards
        startScrolling(); // Begin scrolling
    }
};